import React from 'react';

import { useConversionTable } from 'hooks';
import { useCXI } from 'modules/cxi/useCXI';

import { Option } from '../components/option/Option';

import * as Form from '../components/form';

export const InterestInStartups = () => {
    const { t, vars, addVars } = useCXI();
    const conv = useConversionTable(['interestInStartup']);
    const data = vars.profile.profile.interestInStartups;

    const handleChange = value => {
        let newData = [...data];
        if (data.includes(value)) {
            newData = data.filter(v => v !== value);
        } else {
            newData.push(value);
        }

        const profile = {
            ...vars.profile,
            profile: {
                ...vars.profile.profile,
                interestInStartups: [...newData],
            },
        };
        addVars({ profile });
    };

    return (
        <Form.Form name="InterestInStartups">
            <Form.Title>{t('setup.Titles.interestInStartups')}</Form.Title>
            <Form.Descr>{t('setup.Descrs.interestInStartups')}</Form.Descr>

            <Form.OptionsContainer>
                {Object.keys(conv.interestInStartup)
                    .map(value => parseInt(value, 10))
                    .map(value => (
                        <Option
                            label={conv.interestInStartup[String(value)]}
                            value={value}
                            key={value}
                            checked={!!data.includes(value)}
                            onChange={() => handleChange(value)}
                        />
                    ))}
            </Form.OptionsContainer>
        </Form.Form>
    );
};
